import { required, requiredIf, email as emailValidator, minLength, maxLength, minValue } from 'vuelidate/lib/validators';
import axios from 'axios';
import { utils } from '../utils';


const email = {
  name: 'email',
  throttle: true,
  validators: [
    {
      required,
      message: 'A valid email address is required'
    },
    {
      emailValidator,
      message: 'A valid email address is required'
    },
    {
      isUnique: isUnique('api/public/users/exists', (response) => response === false, true),
      message: 'This email is already registered.'
    },
    {
      maxLength: maxLength(128),
      message: 'Email must be less than 128 characters'
    }
  ]
};

const orgName = {
  name: 'organizationName',
  throttle: true,
  validators: [
    {
      required,
      message: 'Your company name is required.'
    },
    {
      isUnique: isUnique('api/public/organizations/exists', (response) => response === false, true),
      message: 'Organization name is taken, please choose another name'
    },
    {
      maxLength: maxLength(100),
      message: 'Organization must be less than 100 characters'
    }
  ]
};

const firstName = {
  name: 'firstName',
  validators: [
    {
      required,
      message: 'First name is required'
    },
    {
      maxLength: maxLength(50),
      message: 'Your first name cannot be longer than 50 characters'
    },
    {
      minLength: minLength(1),
      message: 'Your first name is required to be at least 1 character'
    }
  ]
};

const lastName = {
  name: 'lastName',
  validators: [
    {
      required,
      message: 'Last name is required'
    },
    {
      maxLength: maxLength(50),
      message: 'Your last name cannot be longer than 50 characters'
    },
    {
      minLength: minLength(1),
      message: 'Your last name is required to be at least 1 character'
    }
  ]
};


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const passwordPolicies = {
  name: 'password',
  validators: [
    {
      required,
      message: 'A password is required'
    },
    {
      minValue: minValue(6),
      message: 'Passwords must contain at least 6 characters'
    },
    {
      required: requiredIf('mustHaveNumerical'),
      numerical: hasNumericalValues,
      message: 'Passwords must contain at least one number!'
    },
    {
      required: requiredIf('mustHaveBlacklist'),
      blacklist: isInBlacklist,
      message: 'Passwords must not be a common password!'
    },
    // {
    //   required: requiredIf('mustHavePersonalInfo'),
    //   personalInfo: excludesPersonalInfo({}),
    //   message: 'Passwords must not have personal information!'
    // },
    {
      required: requiredIf('mustHaveUpperLower'),
      upperLower: hasUpperAndLowerCase,
      message: 'Passwords must have at least one upper and lower case letters!'
    }
  ]
};

export const defaulPasswordPolicies = {
  minLen: 6,
  numerical: false,
  upperLower: false,
  blacklist: false,
  personalInfo: false
};

export function buildPasswordHint(passwordPolicies: any) {
  let hint = '';
  let usedAtLeast = false;
  if (passwordPolicies) {
    hint = 'Min. ' + passwordPolicies.minLen + ' characters';
    if (passwordPolicies.numerical) {
      hint += ' with at least a number';
      usedAtLeast = true;
    }

    if (passwordPolicies.upperLower) {
      if (usedAtLeast) {
        hint += ', one capital letter';
      } else {
        hint += ' with one capital letter';
      }
    }

    if (passwordPolicies.blacklist) {
      hint += ', no common words';
    }

    if (passwordPolicies.personalInfo) {
      hint += ', no personal information';
    }
  }

  return hint;
}

export function isInBlacklist(value: string) {
  window['NBP'].init('mostcommon_100000', '/js/collections/', true);
  return !window['NBP'].isCommonPassword(value);
}

export const excludesPersonalInfo = (param) => (value) => param.firstName != null && param.lastName != null && !value.includes(param.firstName) && !value.includes(param.lastName);

export function hasPesronalInfo(user: any, value: string) {
  return user.firstName != null &&
         user.lastName != null &&
         !value.toLowerCase().includes(user.firstName.toLowerCase()) &&
         !value.toLowerCase().includes(user.lastName.toLowerCase());
}

export function hasNumericalValues(value: string) {
  const matches = value.match(/\d+/g);
  if (matches != null) {
    return true;
  }
  return false;
}

export function hasUpperAndLowerCase(value) {
  const lowerMatch = value.match(/[a-z]/);
  const upperMatch = value.match(/[A-Z]/);
  if (lowerMatch == null || upperMatch == null) {
    return false;
  }
  return true;
}

const data = {
  register: [
    firstName,
    lastName,
    orgName,
    email,
  ],
  // viewerSignup: [
  //   email,
  // ],
  profile: [
    firstName,
    lastName,
    email
  ],
  // adminOrgAddUser: [
  //   firstName,
  //   lastName,
  //   userType,
  //   email
  // ],
  // authorAddUser: [
  //   firstName,
  //   lastName,
  //   userType,
  //   email
  // ],
  // orgName: [
  //   orgName
  // ]
};

export default data;

function isUnique(url, apiGoodResponse, post) {
  return (value) => new Promise((resolve, reject) => {
      doRequest(url, value, apiGoodResponse, post, resolve, reject);
    });
}

function doRequest(url, value, apiGoodResponse, post, resolve, reject) {
  if (value == null || value.length === 0) {
    resolve(true);
  } else {
    const request = post ? axios.post(url, value, { headers: { 'Content-Length': 0, 'Content-Type': 'text/plain' } }) : axios.get(url + value);
    request.then((response) => {
      resolve(apiGoodResponse(response.data.data));
    }).catch((e) => {
      reject();
    });
  }
}

function getValidationData(page) {
  return data[page];
}

function getValidator(data) {
  for (const field in data) {
    if (field !== 'message') {
      return { name: field, value: data[field] };
    }
  }
  return {};
}

export function mapDataBinding(page) {
  return getValidationData(page).reduce((acc, curr) => {
    acc[curr.name + 'Error'] = function() {
      const errors = [];
      if (!this.$v[curr.name].$error || this.$v[curr.name].$pending) {
        return errors;
      }
      curr.validators.forEach((item) => {
        !this.$v[curr.name][getValidator(item).name] && errors.push(item.message);
      });
      return errors;
    };
    acc[curr.name + 'DataBinding'] = function() {
      return {
        value: this[curr.name],
        'error-messages': this[curr.name + 'Error'],
        'append-icon': this.setErrorIcon(curr.name),
        loading: this.$v[curr.name].$pending
      };
    };
    acc[curr.name + 'Listeners'] = function() {
      return {
        input: curr.throttle ? (v) => this.throttle(v, curr.name) : (v) => {
          this[curr.name] = v;
          this.$v[curr.name].$touch();
        },
        blur: () => {
          this.$v[curr.name].$touch();
        }
      };
    };
    return acc;
  }, {});
}

export function validationHelperMethods() {
  return { throttle, setErrorIcon };
}

function throttle(v, fieldName) {
  if (fieldName === 'email') {
    v = v.trim();
  }
  this.waiting = true;
  _throttle(fieldName, () => {
    this.waiting = false;
    this[fieldName] = v;
    this.$v[fieldName].$touch();
  }, 1000);
}

const waiting = {};

function _throttle(fieldName, func, milli) {
  if (waiting[fieldName]) {
    waiting[fieldName].token.cancel = true;
  }
  const waitForASec = utils.wait(milli, null);
  waitForASec['token'] = { cancel: false };
  waitForASec.then(() => {
    if (!waitForASec['token'].cancel) {
      func();
      waiting[fieldName] = null;
    }
  });
  waiting[fieldName] = waitForASec;
}

function setErrorIcon(field) {
  return this.$v[field].$error ? 'error' : '';
}
